// extracted by mini-css-extract-plugin
module.exports = {"chatsNotFound":"ChatUsers_chatsNotFound__227yG","tabs":"ChatUsers_tabs__173AY"};